var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import { styled } from '@web/theme';
import { BlockLibrary, usePageEdit } from '../../../';
import { Palette } from '../Palette';
export var AdminPanels = memo(function (_a) {
    var openPanel = _a.openPanel;
    var enabled = usePageEdit().pageEdit.enabled;
    if (!enabled)
        return null;
    return (React.createElement(Wrapper, null,
        openPanel === 'library' && React.createElement(BlockLibrary, null),
        openPanel === 'palette' && React.createElement(Palette, null)));
});
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  display: flex;\n  flex: none;\n  padding-left: 53px;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  max-width: 350px;\n  box-shadow: 2px 0px 5px 0px rgba(0, 0, 0, 0.75);\n  background: #171c21;\n  transition: width .25s;\n  z-index: 951;\n"], ["\n  position: absolute;\n  display: flex;\n  flex: none;\n  padding-left: 53px;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  max-width: 350px;\n  box-shadow: 2px 0px 5px 0px rgba(0, 0, 0, 0.75);\n  background: #171c21;\n  transition: width .25s;\n  z-index: 951;\n"])));
var templateObject_1;
